"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductClassSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductClassSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductClassSearchResponse = ProductClassSearchResponse;
//# sourceMappingURL=product-class-search.response.js.map